const firebaseConfig = {
  apiKey: "AIzaSyDaPNMgYrJYY8FxlRQ4IkikFmzqEqywlQA",
  authDomain: "auth.freshpaint.io",
  projectId: "freshpaint-1",
  storageBucket: "test-project-c1b2f.appspot.com",
  messagingSenderId: "830445107051",
};

export default firebaseConfig;
